import '@fontsource-variable/manrope'
import '@fontsource/ibm-plex-mono/400.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.scss'

// Apply the saved theme (or the dark default) before the first paint so a
// refresh does not briefly render the wrong palette while React is mounting.
try {
  const savedTheme = window.localStorage.getItem('aiflow-theme')
  const initialTheme = savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : 'dark'
  document.documentElement.dataset.theme = initialTheme
  document.documentElement.style.colorScheme = initialTheme
} catch { /* theme persistence is best effort */ }

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
